// <!-- ใช้งานกับ เมนู Overlap เมื่อเลื่อน scrollbar  ให้เพิ่มคลาส rv-sticky-overlap คลาสอยู่ที่ rvsb-nav-style-xxx.css -->

$(function() {
    $(document).ready(function() {
        $('nav.uk-navbar').attr('data-uk-sticky', '{top:unset}');
    });
    $(document).scroll(function() {
        if ($(this).scrollTop() > 60) {
            $('.uk-sticky-placeholder').addClass('rv-sticky-overlap');
            $('.overlap nav.uk-active').css('background', 'rgba(0,0,0,0.4)');
        } else {
            $('.uk-sticky-placeholder').removeClass('rv-sticky-overlap');
            $('.overlap nav.uk-navbar').css('background', 'inherit');
        }
    });
    $(document).find(function() {
        $('.uk-sticky-placeholder').css({
            height: 'auto !important'
        });
    });
});
